import React from 'react';
import { withFirebase } from '../../Firebase';

const CompaniesUsage = (props) => {
   return <div>Users Usage</div>;
};

export default withFirebase(CompaniesUsage);
